import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/xc/dev/digimaker-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "digimaker-ui"
    }}>{`digimaker-ui`}</h1>
    <p>{`digimaker-ui is the ui components for Digimaker CMF, developed in React. It provides client features like create, edit, delete, actions and other editorial features.`}</p>
    <p>{`Documentation: `}<a parentName="p" {...{
        "href": "https://digimaker.org/doc/digimaker-ui"
      }}>{`https://digimaker.org/doc/digimaker-ui`}</a></p>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <ul>
      <li parentName="ul">{`List(include block view)`}</li>
      <li parentName="ul">{`Main(for building main page for admin site)`}</li>
      <li parentName="ul">{`TreeNode`}</li>
      <li parentName="ul">{`Browse`}</li>
      <li parentName="ul">{`Util. eg. FileUpload`}</li>
      <li parentName="ul">{`Views: content view, version view`}</li>
      <li parentName="ul">{`Actions: create, edit, delete, filter, move, copy, set to top, set priority, assign/unassign role, disable user`}</li>
    </ul>
    <h2 {...{
      "id": "building-admin"
    }}>{`Building admin`}</h2>
    <p><img alt="alt text" src={require("./doc/ui-1.png")} /></p>
    <p><img alt="alt text" src={require("./doc/ui-2.png")} /></p>
    <h2 {...{
      "id": "use-in-app"
    }}>{`Use in app`}</h2>
    <p>{`Browsing:
`}<img alt="alt text" src={require("./doc/ui-3.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      